import React from "react";
import { FlexContainer, LottieLoadingIndicator, PortalLoadingState } from "src/components";

export const PageLoadingContainer = ({ maxWidth, minHeight, width, height }) => {
    return (
        <FlexContainer
            width="100%"
            justifyContent="center"
            alignItems="center"
        >
            <PortalLoadingState
                minHeight={minHeight || "40rem"}
                style={{
                    overflowX: "auto",
                    width: width || "98.625rem",
                    height: height || "40rem",
                    maxWidth: maxWidth || "98.625rem",
                }}
            >
                <LottieLoadingIndicator />
            </PortalLoadingState>
        </FlexContainer>
    );
};
